import React from 'react';
import { Link } from 'react-router-dom';

const blogs = [
    {
        title: "Nurturing your Minds: The Power of Education",
        excerpt: "Education is the foundation of sustainable development and empowerment.",
        image: "/images/blog_education.png",
        author: "Dr. Lakshmi Venkatesan",
        date: "December 15, 2024",
        category: "Education",
        readTime: "5 min read"
    },
    {
        title: "Women Empowerment: A Pathway to Equality and Progress",
        excerpt: "Learn about the transformative impact of women-led entrepreneurship initiatives.",
        image: "/images/blog_women.png",
        author: "Community Team",
        date: "December 10, 2024",
        category: "Empowerment",
        readTime: "6 min read"
    },
    {
        title: "HealthCare for All: The Path to Nation's well-being",
        excerpt: "Explore how comprehensive healthcare support strengthens families and building healthier.",
        image: "/images/blog_healthcare.png",
        author: "Health Initiative Team",
        date: "December 5, 2024",
        category: "Healthcare",
        readTime: "4 min read"
    }
];

const Blog: React.FC = () => {
    return (
        <section id="blog" className="py-20 bg-gradient-to-br from-white via-gray-50 to-white">
            <div className="container mx-auto px-4">
                <div className="text-center max-w-3xl mx-auto mb-16">
                    <h4 className="text-secondary font-bold uppercase tracking-widest mb-2 text-sm">Latest</h4>
                    <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
                        Blogs & <span className="gradient-text">Insights</span>
                    </h2>
                    <p className="text-gray-600 text-lg">
                        Stay informed with our latest articles, stories, and insights on community development, education, and empowerment.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {blogs.map((blog, index) => (
                        <article
                            key={index}
                            className="group bg-white rounded-2xl overflow-hidden shadow-premium hover:shadow-premium-lg transition-all duration-500 transform hover:-translate-y-2 animate-fade-in-up h-full flex flex-col"
                            style={{ animationDelay: `${index * 0.2}s` }}
                        >
                            {/* Image */}
                            <div className="relative overflow-hidden aspect-[16/10]">
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 z-10"></div>
                                <img
                                    src={blog.image}
                                    alt={blog.title}
                                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                                />
                                <div className="absolute top-4 left-4 z-20">
                                    <span className="px-3 py-1 bg-primary text-white text-xs font-bold rounded-full">
                                        {blog.category}
                                    </span>
                                </div>
                            </div>

                            {/* Content */}
                            <div className="p-6 flex flex-col flex-grow">
                                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-primary transition-colors duration-300 line-clamp-2">
                                    {blog.title}
                                </h3>

                                <p className="text-gray-600 mb-4 line-clamp-3 text-sm leading-relaxed flex-grow">
                                    {blog.excerpt}
                                </p>

                                <div className="pt-4 border-t border-gray-100">
                                    <Link
                                        to={`/blog/${blog.title === "HealthCare for All: The Path to Nation's well-being"
                                            ? 'healthcare-for-all-the-path-to-nations-wellbeing'
                                            : blog.title.toLowerCase()
                                                .replace(/[^a-z0-9\s-]/g, '')
                                                .replace(/\s+/g, '-')
                                                .replace(/-+/g, '-')
                                                .replace(/(^-|-$)/g, '')}`}
                                        className="text-primary font-semibold text-sm inline-flex items-center group-hover:translate-x-1 transition-transform"
                                    >
                                        Read More
                                        <svg className="w-4 h-4 ml-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                        </svg>
                                    </Link>
                                </div>
                            </div>
                        </article>
                    ))}
                </div>

                {/* <div className="text-center mt-12">
                    <a
                        href="/blogs"
                        className="inline-flex items-center justify-center bg-white border-2 border-primary text-primary hover:bg-primary hover:text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-premium hover:shadow-premium-lg transform hover:-translate-y-1"
                    >
                        View All Blog Posts
                        <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                        </svg>
                    </a>
                </div> */}
            </div>
        </section>
    );
};

export default Blog;
